'use client';
import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { motion } from 'framer-motion';
import { useState, useEffect, useCallback } from 'react';
import { useKey } from 'react-use';
import styled from 'styled-components';
import { isKey } from '../../helpers/keyboard.js';
import { zIndexUtil } from '../../helpers/zIndexUtil.js';
import { withTitan } from '../../hocs/withTitan/withTitan.js';

const StyledDimmer = styled(motion.div).withConfig({
  shouldForwardProp: prop => !['zIndex'].includes(prop)
}).withConfig({
  componentId: "sc-ccxp8u-0"
})(["position:fixed;background:", ";inset:0;height:100vh;overflow:hidden;z-index:", ";"], ({
  theme
}) => theme.components.dimmer.backgroundColor, ({
  zIndex
}) => zIndex);
const Dimmer = /*#__PURE__*/withTitan((_a, ref) => {
  var {
      onClose,
      zIndex = zIndexUtil.dimmer,
      className,
      testId = 'dimmer',
      children
    } = _a,
    rest = __rest(_a, ["onClose", "zIndex", "className", "testId", "children"]);
  useKey(e => isKey(e, 'ESC'), onClose);
  const [hasScrollClass, setHasScrollClass] = useState(false);
  useEffect(() => {
    const hasOverflow = document.documentElement.classList.contains('has-scroll-y');
    if (hasOverflow) document.documentElement.classList.remove('has-scroll-y');
    setHasScrollClass(!!hasOverflow);
  }, []);
  const handleClose = useCallback(e => {
    if (hasScrollClass) {
      document.documentElement.classList.add('has-scroll-y');
    }
    onClose === null || onClose === void 0 ? void 0 : onClose(e);
  }, [hasScrollClass, onClose]);
  return jsx(StyledDimmer, Object.assign({}, rest, {
    ref: ref,
    className: className,
    "data-test-id": testId,
    zIndex: zIndex,
    onClick: handleClose,
    children: children
  }));
}, {
  name: 'Dimmer'
});

export { Dimmer };
//# sourceMappingURL=Dimmer.js.map
